import React, { useRef, useEffect, useMemo } from "react";
import { useState } from "react";
import { useApp } from "../../contexts";
import { isAddress, truncateString  } from "../../utils/helper";
import { CloseIconRounded } from "../Icons/CloseIconMb";
import { useWindowSize } from "../../hook/useWindowSize";

export default function WithdrawSelectAddress(props) {
  const { value, onChange, options } = props;
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const size = useWindowSize();
  const isMobile = size.width < 768;
  const [keyword, setKeyword] = useState("");
  const [isShowDropdown, setShowDropdown] = useState(false);
  const [isShowInput, setIsShowInput] = useState(true);
  const { T } = useApp();
  const [filterOptions, setFilterOptions] = useState([]);
  const [showPaste, $showPaste] = useState(true);
  const [itemSelected, $itemSelected] = useState(null);

  const handleOnPaste = () => {
    navigator.clipboard.readText().then((cliptext) => {
      setKeyword(cliptext);
      const itemByText = options.find((opt) => opt.value === cliptext);
      if (itemByText) {
        onChange(itemByText.value);
        $itemSelected(itemByText);
        setIsShowInput(false);
        setShowDropdown(false)
      }else{
        if (isAddress(cliptext)) {
          onChange(cliptext)
        }
        setShowDropdown(true)
      }
    }).catch((error) => {
      console.error("Failed to read clipboard contents: ", error);
    });
    $showPaste(false);
  };
  useEffect(() => {
    const itemByValue = options.find((opt) => opt.value === value);
    if (itemByValue) {
      $itemSelected(itemByValue);
      setIsShowInput(false);
      setShowDropdown(false);
    }
  }, [value, options])

  const handleOnRemove = () => {
    setKeyword("");
    $showPaste(true);
  };
  function handleClickOutside(event) {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowDropdown(false);
      if (itemSelected) {
        setIsShowInput(false);
      }
    }
  }
  const hanldeChangeKeyword = (val) => {
    if (isAddress(val)) {
      onChange(val)
    }
    setKeyword(val)
  }
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const highlightText = (text, search) => {
    if (!search.trim()) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<span class='text-aia-red'>$1</span>");
  };
  const onSelectItem = (option) => {
    setShowDropdown(false);
    setIsShowInput(false);
    onChange(option.value);
    $itemSelected(options.find((opt) => opt.value === option.value));
  };

  const handleClickHeader = () => {
    setShowDropdown(true);
    setIsShowInput(true);
    setKeyword(keyword ? keyword : (itemSelected?.label || ''));
  };
  const handleAddAddress = (keyword) => {
    setShowDropdown(false);
    props?.onAddAddress(keyword);
  };
  const handleClear = () => {
    onChange(null);
    inputRef?.current?.focus();
    setKeyword("");
    setShowDropdown(true);
    $itemSelected(null);
  };
  const searchListOptions = (key) => {
    const results = (options || [])
      .filter((item) => item.label.toLowerCase().includes(key.toLowerCase()) || item.value.toLowerCase().includes(key.toLowerCase()))
      .map((option, index) => {
        return {
          ...option,
          key: index
        };
      });
    setFilterOptions(results);
  };
  useEffect(() => {
    searchListOptions(keyword);
  }, [keyword, options]);

  const checkShowDropdown = useMemo(() => {
    if (options.length > 0) {
      return isShowDropdown;
    }
    if (keyword.length > 0) {
      return isShowDropdown;
    }
    return false;
  }, [keyword, options, isShowDropdown])

  return (
    <div ref={wrapperRef} className="relative w-full">
      <div className="address-book-search relative">
        {/* {itemSelected && !isShowInput && (
          <div className="address-book-search-prefix absolute left-[12px] top-[22px]">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                fill="url(#paint0_linear_11455_76680)"
              />
              <path
                d="M12 5L6.5 10.5L4 8"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_11455_76680"
                  x1="0"
                  y1="8.00055"
                  x2="16.0008"
                  y2="8.00055"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#E5665B" />
                  <stop offset="0.00022375" stopColor="#E5665B" />
                  <stop offset="0.2" stopColor="#BC2DBD" />
                  <stop offset="0.201284" stopColor="#BC2DBD" />
                  <stop offset="0.51" stopColor="#5F00A7" />
                  <stop offset="0.512073" stopColor="#5F00A7" />
                  <stop offset="0.72" stopColor="#393DB8" />
                  <stop offset="0.720835" stopColor="#393DB8" />
                  <stop offset="1" stopColor="#048ACC" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        )} */}
        {itemSelected && !isShowInput ? (
          <div
            className="h-[60px] w-full pl-[20px] lg:max-w-full bg-white flex rounded-[10px] text-black"
            onClick={() => handleClickHeader()}
          >
            <div className="flex flex-col justify-center gap-[2px] pr-[15px] items-start">
              <div className="text-[#818181] text-[14px] font-normal">
                {itemSelected?.label}
              </div>
              <div className="text-[#000000] text-[16px] font-normal">
                {isMobile ? truncateString(itemSelected.value, 7, 5) : itemSelected.value} 
              </div>
            </div>
          </div>
        ) : (
          <input
            className="h-[50px] w-full pl-[20px] lg:max-w-full py-3 pr-12 bg-white rounded-[10px] text-black"
            placeholder={props?.placeholder}
            ref={inputRef}
            onChange={(e) => hanldeChangeKeyword(e.target.value)}
            onClick={() => {
              setShowDropdown(true)
            }}
            value={keyword}
          />
        )}
        {!showPaste || itemSelected ? (
          <>
            <div
              onClick={() => {
                handleOnRemove();
                handleClear();
              }}
              className={`cursor-pointer absolute text-[14px] right-[16px] ${
                itemSelected && !isShowInput ? "top-[20px]" : "top-[14px]"
              }`}
            >
              <CloseIconRounded className={"w-5 h-5"} />
            </div>
          </>
        ) : (
          <div className="absolute text-[14px] right-[16px] top-[14px] bg-white">
              <div
              className="text-aia-red cursor-pointer "
              onClick={() => handleOnPaste()}
            >
              {T("Paste")}
            </div>
          </div>
        )}
      </div>
      <div
        className={`absolute top-[58px] left-0 bg-white w-full rounded-[8px] ${
          checkShowDropdown ? "block" : "hidden"
        } z-[9999]`}
      >
        <div className="address-book-search-list">
          {filterOptions?.length == 0 ? (
            <>
              {isAddress(keyword) ? (
                <span
                  className="text-aia-red-400 cursor-pointer"
                  onClick={() => handleAddAddress(keyword)}
                >
                  {T("+ Add this address to your address book")}
                </span>
              ) : keyword ? (
                <span className="text-red-500 cursor-pointer">
                  {T("Not found this name in address book")}
                </span>
              ) : null}
            </>
          ) : (
            <>
              {filterOptions?.map((option) => (
                <>
                  <div
                    className={`address-book-search-item cursor-pointer ${option.value === itemSelected?.value ? 'active' : ''}`}
                    onClick={() => onSelectItem(option)}
                  >
                    <div className="address-book-search-item-label">
                      <div className="text-base text-black leading-[22px] truncate">
                        <div
                          className="py-1"
                          dangerouslySetInnerHTML={{
                            __html: highlightText(option.label, keyword),
                          }}
                        />
                      </div>
                      <div className="text-xs text-[#818181] leading-[20px] mt-[2px] address-book_address">
                        <div
                          className="py-1"
                          dangerouslySetInnerHTML={{
                            __html: highlightText(isMobile ? truncateString(option.value, 7, 5) : option.value, keyword),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
